import { motion } from "framer-motion";
import { Calendar, Globe, Users } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function ShortTerm() {
    const { t } = useT();
    const stats = [
        { icon: Calendar, value: "365", label: t("st.stat1_label") },
        { icon: Globe, value: "180+", label: t("st.stat2_label") },
        { icon: Users, value: t("st.stat3_value"), label: t("st.stat3_value_label") },
    ];
    return (
        <section
            className="relative py-24 md:py-32 bg-charcoal-surface overflow-hidden"
            data-testid="short-term-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="max-w-3xl"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <span className="inline-block w-8 h-[1px] bg-gold" />
                        <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                            {t("st.overline")}
                        </span>
                    </div>
                    <h2 className="font-display text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
                        {t("st.heading")}
                    </h2>
                    <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed">
                        {t("st.body")}
                    </p>
                </motion.div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
                    {stats.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.label}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: i * 0.1 }}
                                className="p-8 border border-white/10 bg-charcoal hover:border-gold/40 transition-colors group"
                                data-testid={`short-term-stat-${i}`}
                            >
                                <Icon size={20} className="text-gold mb-6" strokeWidth={1.5} />
                                <div className="font-display text-4xl md:text-5xl font-bold text-white tracking-tight">
                                    {s.value}
                                </div>
                                <div className="mt-2 text-[11px] tracking-[0.3em] uppercase text-white/50">
                                    {s.label}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>

                <p className="mt-12 text-xs text-white/40 italic max-w-2xl">
                    {t("st.disclaimer")}
                </p>
            </div>
        </section>
    );
}
